module.exports = __webpack_public_path__ + "img/small_whale09.1b0ce091.jpg";